import {
  Container,
  Flex,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Tfoot,
  Th,
  Thead,
  Tr,
  Text,
  Link,
  Button,
  UnorderedList,
  ListItem,
  WrapItem,
  HStack
} from '@chakra-ui/react';
import {FiExternalLink} from 'react-icons/fi';
import {BsStar, BsStarHalf, BsStarFill} from 'react-icons/bs';

export const FeaturePage: React.FC = () => {
  return (
    <Container maxW='100%'>
      <Flex p={8} flexDir='column' gap={4}>
        <TableContainer width='100%'>
          <Table variant='simple'>
            <TableCaption fontSize='lg' placement='top'>
              Component Library Comparison
            </TableCaption>
            <Thead>
              <Tr>
                <Th width='20%'></Th>
                <Th width='40%'>
                  <Text fontSize='lg' color='teal.500'>
                    chakra-ui
                  </Text>
                </Th>
                <Th width='40%'>
                  <Text fontSize='lg' color='error.500'>
                    bm-ui-components
                  </Text>
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Th>Components</Th>
                <Td>
                  <WrapItem gap={4}>
                    51 all purpose components organized in 9 categories (+210
                    with chakra pro)
                    <Button
                      rightIcon={<FiExternalLink />}
                      variant='link'
                      colorScheme='blue'
                      as='a'
                      href='https://chakra-ui.com/docs/components'
                      target='_blank'
                    >
                      link
                    </Button>
                  </WrapItem>
                  Under active development, 28K Stars in github, frequent
                  updates
                </Td>
                <Td>
                  <WrapItem gap={4}>
                    53, 29 all purpose, 24 app specific, maintained by
                    organization
                    <Button
                      rightIcon={<FiExternalLink />}
                      variant='link'
                      colorScheme='blue'
                      as='a'
                      href='https://design.bettermarks.com/?path=/story/docs-introduction--page'
                      target='_blank'
                    >
                      link
                    </Button>
                  </WrapItem>
                </Td>
              </Tr>
              <Tr>
                <Th>Design</Th>
                <Td colSpan={2}></Td>
              </Tr>
              <Tr>
                <Td>Design Kit</Td>
                <Td>
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStar />
                    <BsStar />
                  </HStack>
                  Figma, incomplete (not often updated)
                </Td>
                <Td>
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStar />
                    <BsStar />
                    <BsStar />
                    <BsStar />
                  </HStack>
                  Figma, very incomplete (only some components)
                </Td>
              </Tr>

              {/* <Tr>
                <Td>Design Library</Td>
                <Td></Td>
                <Td>Only some components in Figma</Td>
              </Tr> */}

              <Tr>
                <Th>Developer Experience</Th>
                <Td colSpan={2}></Td>
              </Tr>
              <Tr>
                <Td>Customisability</Td>
                <Td>
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                  </HStack>
                  Highly customisable
                  <UnorderedList>
                    <ListItem>prop overrides</ListItem>
                    <ListItem>easy responsive styling system</ListItem>
                    <ListItem>global styles</ListItem>
                    <ListItem>(external) component styles</ListItem>
                    <ListItem>variants</ListItem>
                    <ListItem>
                      styling third party libraries via charka factory
                    </ListItem>
                    <ListItem>color modes</ListItem>
                  </UnorderedList>
                </Td>
                <Td>
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStar />
                    <BsStar />
                    <BsStar />
                    <BsStar />
                  </HStack>
                  difficult to customize components externally
                </Td>
              </Tr>
              <Tr>
                <Th>Tooling</Th>
                <Td>
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                  </HStack>
                  <UnorderedList>
                    <ListItem>Typescript</ListItem>
                    <ListItem>styled system</ListItem>
                  </UnorderedList>
                </Td>
                <Td>
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStar />
                  </HStack>
                  <UnorderedList>
                    <ListItem>Typescript</ListItem>
                    <ListItem>styled-components</ListItem>
                  </UnorderedList>
                </Td>
              </Tr>
              <Tr>
                <Td>Scalability</Td>
                <Td>
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStar />
                  </HStack>
                  <UnorderedList>
                    <ListItem>design Tokens</ListItem>
                    <ListItem>semanticTokens</ListItem>
                    <ListItem>themable</ListItem>
                  </UnorderedList>
                </Td>
                <Td>
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStar />
                    <BsStar />
                    <BsStar />
                    <BsStar />
                  </HStack>
                  doesn't scale well, no semanticTokens
                </Td>
              </Tr>
              <Tr>
                <Td>Composition</Td>
                <Td>
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStar />
                  </HStack>
                  highly and easily composable
                  <UnorderedList>
                    <ListItem>
                      <Button
                        rightIcon={<FiExternalLink />}
                        variant='link'
                        colorScheme='blue'
                        as='a'
                        href='https://chakra-templates.dev/'
                        target='_blank'
                      >
                        chakra templates
                      </Button>
                    </ListItem>
                    <ListItem>
                      <Button
                        rightIcon={<FiExternalLink />}
                        variant='link'
                        colorScheme='blue'
                        as='a'
                        href='https://pro.chakra-ui.com/'
                        target='_blank'
                      >
                        chakra pro
                      </Button>
                    </ListItem>
                  </UnorderedList>
                </Td>
                <Td>
                  {' '}
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStar />
                    <BsStar />
                    <BsStar />
                    <BsStar />
                  </HStack>
                  not easily composable
                </Td>
              </Tr>
              <Tr>
                <Td>Documentation</Td>
                <Td>
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStar />
                  </HStack>
                  Excellent: Maintained by organization, backed by community,
                  lots of examples
                </Td>
                <Td>
                  {' '}
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStar />
                    <BsStar />
                    <BsStar />
                    <BsStar />
                  </HStack>
                  internally maintained, in progress but sparse
                </Td>
              </Tr>
              <Tr>
                <Th colSpan={3}>Accessibility & SEO</Th>
              </Tr>
              <Tr>
                <Td>Accessibility</Td>
                <Td>
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStar />
                    <BsStar />
                  </HStack>
                  <Text>
                    Good accessiblity features OOB but manual work necessary
                    (aria-label, alt text on img, etc)
                  </Text>
                </Td>
                <Td>
                  {' '}
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStar />
                    <BsStar />
                    <BsStar />
                    <BsStar />
                  </HStack>
                  Only manual work
                </Td>
              </Tr>
              <Tr>
                <Td>SEO</Td>
                <Td>
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                    <BsStarFill fill='#ff9200' />
                  </HStack>
                  Excellent "polymorphism" via the "as" prop, semantic markup
                  can be chosen for every component
                </Td>
                <Td>
                  <HStack mb={4}>
                    <BsStarFill fill='#ff9200' />
                    <BsStar />
                    <BsStar />
                    <BsStar />
                    <BsStar />
                  </HStack>
                  Only manual work, markup depends on components, some
                  "polymorphism" via "as" prop in styled-components
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer>
        {/* <TableContainer width='100%'>
          <Table variant='simple'>
            <TableCaption>Imperial to metric conversion factors</TableCaption>
            <Thead>
              <Tr>
                <Th>Pros</Th>
                <Th>Cons</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>customisability</Td>
                <Td>millimetres (mm)</Td>
              </Tr>
              <Tr>
                <Td>developer experience</Td>
                <Td>centimetres (cm)</Td>
              </Tr>
              <Tr>
                <Td>accessibility</Td>
                <Td>metres (m)</Td>
              </Tr>
            </Tbody>
          </Table>
        </TableContainer> */}
      </Flex>
    </Container>
  );
};
